module.exports = __webpack_public_path__ + "static/media/016-bolt.22383c3f.svg";